export const NavigationButtons = ({
    appTheme,
    programDelete,
    assetInfo,
    toGetAssetInfo,
    gridList,
    viewType,
    newGridData,
    locationState,
    setShouldSort
}) => {
    return (
        <div className={`bottom-container-buttons`}>
            <div className="buttons-container p-2 d-flex justify-content-between">
                <a 
                    className={`btn btn-secondary w-50 me-2 radius-8x ${appTheme === "dark"? 'text-white': ''}`} 
                    onClick={(e) => {
                        if (viewType === "expandView") {
                            programDelete(e, assetInfo?.uuid);
                        } else {
                            programDelete(assetInfo?.sequence - 1);
                        }
                    }}
                    style={{
                        height: "2rem",
                        width: "8.625rem"
                    }}
                >Delete</a>
                <a 
                    className="btn btn-danger w-50 mx-2 radius-8x"
                    onClick={(e) => { 
                        if (viewType === "expandView") {
                            e.preventDefault();
                            if ((assetInfo?.indexValue) > 0) {
                                toGetAssetInfo(assetInfo?.indexValue - 1);
                                document
                                .getElementById(`sequenceId${assetInfo?.indexValue - 1}`)
                                ?.scrollIntoView({ behavior: "smooth" });
                            }
                        } else {
                            e.preventDefault();
                            if ((assetInfo?.sequence - 1) > 0) {
                                setShouldSort(assetInfo?.sequence);
                                setTimeout(() => {
                                    toGetAssetInfo(assetInfo?.sequence - 1);
                                }, 300);
                                document
                                .getElementById(`sequenceId${assetInfo?.sequence - 1}`)
                                ?.scrollIntoView({ behavior: "smooth" }); // Scroll to target section
                            }
                        }
                    }}
                    style={{
                        height: "2rem",
                        width: "8.625rem"
                    }}
                >Previous</a>
                <a 
                    className="btn btn-primary w-50 ms-2 radius-8x"
                    onClick={(e) => {
                        if (viewType === "expandView") {
                            e.preventDefault();
                            if ((assetInfo?.indexValue) < newGridData?.find(item => item?.date === locationState?.state?.panelDate).scheduleItems.length) {
                                toGetAssetInfo(assetInfo?.indexValue + 1);
                                document
                                .getElementById(`sequenceId${assetInfo?.indexValue + 1}`)
                                ?.scrollIntoView({ behavior: "smooth" });
                            }
                        } else {
                            e.preventDefault();
                            if (assetInfo?.sequence < gridList.length) {
                                setShouldSort(assetInfo?.sequence);
                                setTimeout(() => {
                                    toGetAssetInfo(assetInfo?.sequence + 1);
                                }, 300);
                                document
                                .getElementById(`sequenceId${assetInfo?.sequence + 1}`)
                                ?.scrollIntoView({ behavior: "smooth" }); // Scroll to target section
                            }
                        }
                    }}
                    style={{
                        height: "2rem",
                        width: "8.625rem"
                    }}
                >Next</a>
            </div>
        </div>
    )
}